import React from 'react'
import PropTypes from 'prop-types'
import { StyleSheet, css } from 'aphrodite'
import { useTranslation } from 'react-i18next'
import {
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  Box,
} from '@chakra-ui/react'
import { leToBr } from '../utils/Utils'

const styles = StyleSheet.create({
  title: {
    margin: '1em 0em',
    fontSize: '2em',
    fontWeight: 700,
  },
  question: {
    margin: 0,
    fontSize: '1.6em',
    fontWeight: '500',
  },
  iconQuestion: {
    fontWeight: 700,
    fontSize: '2.5em',
    margin: 0,
  },
  containerQuestions: {
    margin: '0em 45em 0em 2em',
  },
  accord: {
    display: 'flex',
    minHeight: '600px',
    width: '80vw',
    flexWrap: 'nowrap',
    flexDirection: 'column',
    margin: '0px 10% 0px 10%',
    borderColor: 'white',
    paddingBottom: '40px',
    gap: '10px',
    '@media (max-width: 480px)': {
      height: 'auto',
    },
  },
  box: {
    outline: '0px solid',
    borderColor: 'transparant',
  },
  QuestionsAnswers: {
    paddingLeft: '15px',
  },
  link: {
    color: '#000',
    textDecoration: 'none',
  },
})

const QuestionsAnswersViewer = ({ from }) => {
  const { t } = useTranslation('translation')

  const listQuestions = [
    t(`faqviewer.question1.${from}`),
    t('faqviewer.question2'),
    t('faqviewer.question3'),
    t('faqviewer.question4'),
    t('faqviewer.question5'),
    t('faqviewer.question6'),
    t('faqviewer.question7'),
    t('faqviewer.question8'),
  ]
  const listAnswers = [
    '',
    leToBr(t('faqviewer.answer2')),
    leToBr(t('faqviewer.answer3')),
    leToBr(t('faqviewer.answer4')),
    leToBr(t('faqviewer.answer5')),
    leToBr(t('faqviewer.answer6')),
    leToBr(t('faqviewer.answer7')),
    leToBr(t('faqviewer.answer8')),
  ]

  const answerList = {
    home: ['a1', 'a2', 'a3', 'a4', 'a5', 'a6', 'a7', 'a8', 'a9', 'a10', 'a11'],
    pro: ['a5', 'a11', 'a6', 'a7', 'a4'],
    part: ['a1', 'a2', 'a3', 'a6', 'a8', 'a9', 'a10'],
  }

  return (
    <div id="question">
      <Accordion className={css(styles.accord)}>
        <h2 className={css(styles.title)}>
          {t('pages.beAMaker.titleQuestionsAnswers')}
        </h2>
        {listQuestions.map((question, index) => (
          <>
            <AccordionItem>
              {({ isExpanded }) => (
                <>
                  <AccordionButton
                    borderColor="transparent"
                    backgroundColor={'white'}
                  >
                    <Box
                      flex="1"
                      textAlign="left"
                      className={css(styles.question)}
                    >
                      {question}{' '}
                    </Box>
                    {isExpanded ? (
                      <span className={css(styles.iconQuestion)}>-</span>
                    ) : (
                      <span className={css(styles.iconQuestion)}>+</span>
                    )}
                  </AccordionButton>
                  <AccordionPanel
                    pb={4}
                    className={css(styles.QuestionsAnswers)}
                  >
                    {index > 0 && listAnswers && listAnswers.at(index)}
                    {index === 0 && (
                      <ul>
                        {answerList[from].map((ans) => (
                          <li key={`${from}${ans}`}>
                            {ans === 'a1' && (
                              <a
                                href="/assets/faq-csp.pdf"
                                target="_blank"
                                className={css(styles.link)}
                                dangerouslySetInnerHTML={{
                                  __html: t('faqviewer.answer1.a1'),
                                }}
                              />
                            )}
                            {ans === 'a2' && (
                              <a
                                href="/assets/faq-etudiant.pdf"
                                target="_blank"
                                className={css(styles.link)}
                                dangerouslySetInnerHTML={{
                                  __html: t('faqviewer.answer1.a2'),
                                }}
                              />
                            )}
                            {ans === 'a3' && (
                              <a
                                href="/assets/faq-primo-accedants.pdf"
                                target="_blank"
                                className={css(styles.link)}
                                dangerouslySetInnerHTML={{
                                  __html: t('faqviewer.answer1.a3'),
                                }}
                              />
                            )}
                            {ans === 'a4' && (
                              <a
                                href="/assets/faq-evenementiel.pdf"
                                target="_blank"
                                className={css(styles.link)}
                                dangerouslySetInnerHTML={{
                                  __html: t('faqviewer.answer1.a4'),
                                }}
                              />
                            )}
                            {ans === 'a5' && (
                              <a
                                href="/assets/faq-decisionnaires.pdf"
                                target="_blank"
                                className={css(styles.link)}
                                dangerouslySetInnerHTML={{
                                  __html: t('faqviewer.answer1.a5'),
                                }}
                              />
                            )}
                            {ans === 'a6' && (
                              <a
                                href="/assets/faq-renovation.pdf"
                                target="_blank"
                                className={css(styles.link)}
                                dangerouslySetInnerHTML={{
                                  __html: t('faqviewer.answer1.a6'),
                                }}
                              />
                            )}
                            {ans === 'a7' && (
                              <a
                                href="/assets/faq-foncier.pdf"
                                target="_blank"
                                className={css(styles.link)}
                                dangerouslySetInnerHTML={{
                                  __html: t('faqviewer.answer1.a7'),
                                }}
                              />
                            )}
                            {ans === 'a8' && (
                              <a
                                href="/assets/faq-reception.pdf"
                                target="_blank"
                                className={css(styles.link)}
                                dangerouslySetInnerHTML={{
                                  __html: t('faqviewer.answer1.a8'),
                                }}
                              />
                            )}
                            {ans === 'a9' && (
                              <a
                                href="/assets/faq-expatries.pdf"
                                target="_blank"
                                className={css(styles.link)}
                                dangerouslySetInnerHTML={{
                                  __html: t('faqviewer.answer1.a9'),
                                }}
                              />
                            )}
                            {ans === 'a10' && (
                              <a
                                href="/assets/faq-voyageurs.pdf"
                                target="_blank"
                                className={css(styles.link)}
                                dangerouslySetInnerHTML={{
                                  __html: t('faqviewer.answer1.a10'),
                                }}
                              />
                            )}
                            {ans === 'a11' && (
                              <a
                                href="/assets/faq-pilotage-projet.pdf"
                                target="_blank"
                                className={css(styles.link)}
                                dangerouslySetInnerHTML={{
                                  __html: t('faqviewer.answer1.a11'),
                                }}
                              />
                            )}
                          </li>
                        ))}
                      </ul>
                    )}
                  </AccordionPanel>
                </>
              )}
            </AccordionItem>
          </>
        ))}
      </Accordion>
    </div>
  )
}

QuestionsAnswersViewer.propTypes = {
  from: PropTypes.string,
}

export default QuestionsAnswersViewer
